<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }" [for]="name">
  {{ label }}
</label>

<div class="control-wrapper">
  <div class="control-container">
    <div [ngClass]="{ 'h-radio-btn-group': style === 'horizontal', 'v-radio-btn-group': style === 'vertical' }">
      <p-radioButton
        *ngFor="let option of options"
        [name]="name"
        label="{{ option.label }}"
        [value]="option.value"
        [(ngModel)]="selectedValue"
        (onClick)="selectValue(option.value)"
        [disabled]="control.disabled || forceDisable"></p-radioButton>
    </div>
    <app-errors [errors]="errors" [showErrors]="!control.pristine && !control.disabled"></app-errors>
  </div>
</div>
